import React, { useState, useMemo } from "react";

import { Accordion, AccordionTab } from 'primereact/accordion';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Checkbox } from "primereact/checkbox";
import { FiltroDeputato, FiltroData } from "../filters";
import { SEDI_CONFIG } from "../../data/sedi";
import { REACT_APP_SEARCH } from '../../config';
import axios from 'axios';

const INITIAL_STATE = {
    sedi: [],
    deputato: [],
    data: { start: null, end: null },
    ricerca: "LC"
};

export default function FiltroProgettoDiCostituzione({ onResults, setLoading, setError, searched, onNuovaRicerca }) {
    const [filtri, setFiltri] = useState(INITIAL_STATE);


    const update = (campo) => (valore) =>
        setFiltri((prev) => ({ ...prev, [campo]: valore }));

    /* ── handler checkbox ── */

    const handleCheckSede = (key, checked) => {
        setFiltri((prev) => {
            if (checked) {
                // se non è già presente, aggiungi con argomento null
                if (!prev.sedi.some((s) => s.descrizione === key)) {
                    return {
                        ...prev,
                        sedi: [...prev.sedi, { descrizione: key, argomento: null }],
                    };
                }
                return prev;
            }
            // deseleziona: rimuovi tutte le entry per questa sede
            return {
                ...prev,
                sedi: prev.sedi.filter((s) => s.descrizione !== key),
            };
        });
    };

    /* ── handler dropdown argomento ── */

    const handleArgomento = (key, value) => {
        setFiltri((prev) => {
            const exists = prev.sedi.some((s) => s.descrizione === key);
            if (value != null) {
                // aggiorna o aggiungi
                if (exists) {
                    return {
                        ...prev,
                        sedi: prev.sedi.map((s) =>
                            s.descrizione === key ? { ...s, argomento: value } : s
                        ),
                    };
                }
                return {
                    ...prev,
                    sedi: [...prev.sedi, { descrizione: key, argomento: value }],
                };
            }
            // value è null: rimuovi argomento ma mantieni la sede se era checked
            if (exists) {
                return {
                    ...prev,
                    sedi: prev.sedi.map((s) =>
                        s.descrizione === key ? { ...s, argomento: null } : s
                    ),
                };
            }
            return prev;
        });
    };


    const rows = useMemo(
        () =>
            SEDI_CONFIG.map((s) => {
                const entry = filtri.sedi.find((e) => e.descrizione === s.label);
                return {
                    key: s.label,
                    label: s.label,
                    descrizione: s.descrizione,
                    argomenti: s.argomenti,
                    checked: !!entry,
                    argomento: entry?.argomento ?? null,
                };
            }),
        [filtri.sedi]
    );

    /* ── template colonne ── */

    const checkboxBody = (rowData) => (
        <Checkbox
            checked={rowData.checked}
            onChange={(e) => handleCheckSede(rowData.label, e.checked)}
        />
    );

    const sedeBody = (rowData) => (

        <div>
            <span>{rowData.label}</span><br></br>
            <span style={{ fontSize: "0.85rem" }}>{rowData.descrizione}</span>
        </div>

    );

    const argomentoBody = (rowData) => (
        <Dropdown
            value={rowData.argomento}
            options={rowData.argomenti}
            onChange={(e) => handleArgomento(rowData.label, e.value)}
            placeholder=""
            showClear
            filter
            className="w-full"
        />
    );

    const handleSubmit = async () => {
        setLoading?.(true);
        setError?.('');

        try {
            const { data: risultati } = await axios.post(REACT_APP_SEARCH, filtri);
            onResults?.({ risultati, label: 'Leggi' });
        } catch (err) {
            console.error('Errore caricamento risultati Leggi', err);
            onResults?.({ risultati: [], label: 'Leggi' });
            setError?.(err.response?.data?.message || err.message || 'Errore nel caricamento dei risultati.');
        } finally {
            setLoading?.(false);
        }
    };

    return (
        <div>
            <Accordion multiple activeIndex={[0]}>
                <AccordionTab header="Argomento">
                    <div>
                        <DataTable value={rows} dataKey="key" size="small" stripedRows className="w-full">
                            <Column body={checkboxBody} style={{ width: "1rem" }} />
                            <Column header="Sede" body={sedeBody} style={{ width: "16rem" }} />
                            <Column header="Argomento" body={argomentoBody} />
                        </DataTable>
                    </div>
                </AccordionTab>
                <AccordionTab header="Deputato">
                    <FiltroDeputato value={filtri.deputato} onChange={update('deputato')} />
                </AccordionTab>
                <AccordionTab header="Data">
                    <FiltroData value={filtri.data} onChange={update('data')} />
                </AccordionTab>
            </Accordion>

            <div className="mt-4 flex justify-content-center gap-2">
                <Button label="Avvia la ricerca" size="small" severity="success" onClick={handleSubmit} />
                {searched && (
                    <Button
                        label="Nuova ricerca"
                        severity="secondary"
                        size="small"
                        outlined
                        onClick={onNuovaRicerca}
                    />
                )}
            </div>
        </div>
    );
}
